import React from 'react'
import { useParams } from 'react-router-dom';
import AdminMembershipForm from '../../Components/AdminMemberShipForm';

export default function UserForm() {
    const {step} = useParams();
    const renderComp = () => {
        switch (step) {
            case "membership-form":
                return <AdminMembershipForm />;
            default:
                return <AdminMembershipForm />;
        }
    }
  return (
    <>{renderComp()}</>
  )
}
